<template>
  <base-layout>
    <template v-slot:header>
      <app-header />
    </template>
    <template v-slot:banner>
      <Banner :title="title" />
    </template>
    <template v-slot:default>
      <div class="row">
      <div class="col-md-6">
<p>
Angaben gemäß § 5 TMG:<br/>
Sanibands GbR <br/>
Samuel, Abiodun James & Elesin, Olalekan Fuad GbR <br/>
</p>
<p>
Address: <br/>
Friedrichstraße 123<br/>
10117 Berlin<br/>
</p>
<p>
Contat:

Telefon: (+49) 01744 822 370 <br/>
E-Mail: info@sanitizerwristbands.com<br/>
</p>
      </div>
      </div>
    </template>

    <template v-slot:footer>
      <app-footer />
    </template>
  </base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Banner from '@/components/Breadcrumb'
import BaseLayout from '@/layout/BaseLayout'

export default {
  title: 'Imprint',
  components: {
    BaseLayout,
    AppHeader,
    Banner,
    AppFooter
  },
  data () {
    return {
      title: 'Imprint'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Imprint.vue